import DapDSListItem from './list-item.component'

export * from './list-item.component'
export default DapDSListItem

DapDSListItem.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-list-item': DapDSListItem
  }
}
